import {Button, Col, Row} from 'react-bootstrap';
import styled from 'styled-components';
import {COLORS} from '../../constants';
import Select from '../layout/Select';

export const TitleButton = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
  background: linear-gradient(to left, rgb(90, 18, 111) 0%, rgb(201, 0, 95) 100%);
  border: 0;
  font-size: 15px;
  font-family: Segoe UI Bold, 'sans-serif';
  height: 40px;
`;

export const GradientCol = styled(Col)`
  text-align: center;
`;

export const Input = styled.input`
  color: #2a2a62;
  background: ${({disabled}) => disabled ? COLORS.BACKGROUND_GRAY : COLORS.WHITE};
  margin-bottom: 10px;
  ${({empty}) =>
    empty &&
  `
    box-shadow: 0 0 5px rgba(255,0,0,1);
  `}
`;

export const Div = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  margin-top: 15px;
`;

export const CancelButton = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
    background: #9191b7;
    border: 0;
    width: 100%;
    margin-top: 30px;
    height: 40px;
    font-size: 15px;
    font-family: Segoe UI Bold, 'sans-serif';
    border-radius: 5px;
    color: white;
`;

export const PermanentDeleteButton = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
    background: linear-gradient(to left, rgb(90, 18, 111) 0%, rgb(201, 0, 95) 100%);
    border: 0;
    width: auto;
    height: auto;
    margin-top: 0;
    height: 40px;
    font-size: 15px;
    font-family: Segoe UI Bold, 'sans-serif';
    border-radius: 5px;
    color: white;
`;


export const LoginBackButton = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
  background: #9191b7;
    border: 0;
    width: 100%;
    margin-top: 30px;
    height: 40px;
    font-size: 15px;
    font-family: Segoe UI Bold, 'sans-serif';
    border-radius: 5px;
    color: white;
`;

export const FooterRow = styled(Row)`
  margin-top: 30px;
  margin-bottom: 10px;
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileLabel = styled.label`
  height: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  cursor: ${({disabled}) => disabled ? 'cursor' : 'pointer'};
  color: #5e5f89;
  font-weight: bold;
  background-color: ${({disabled}) => disabled ? '#e4e7ea' : COLORS.WHITE};
  border-radius: 5px;
  border: 0.5px solid #d0d1df;
  padding: 0.5rem;
  font-size: 12px;
  ${({empty}) =>
    empty &&
  `
    box-shadow: 0 0 5px rgba(255,0,0,1);
    `}
`;

export const FileNameDiv = styled.div`
  flex-grow: 1;
`;

export const DeleteLogoButton = styled.div`
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  margin-right: 5px;
  border: 0;
  width: 25px;
  height: 25px;

  &:hover {
    color: #fff;
    background-color: #1b8eb7;
    border-color: #1985ac;
    cursor: pointer;
  }
`;

export const FileDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #bebfd3;
  width: 100px;
  height: 40px;
  margin-right: -9px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 14px;
`;

export const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
  margin-left: 6px;
`;

export const CenteredTd = styled.td`
  text-align: center;
`;

export const CustomSelect = styled(Select)`
    height: 38px;
    min-width: 100px;
    width: 100%;
    margin: 0;
    padding-right: 30px;
    font-size: inherit;
    ${({empty}) =>
    empty &&
    `
      box-shadow: 0 0 5px rgba(255,0,0,1);
    `}
`;

export const CenteredP = styled.p`
  text-align: center;
`;

export const LoadingContainer = styled.div`
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeadDiv = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-family: 'Segoe UI', sans-serif;
  font-size: 12px;
  padding-top: 0;
  padding-bottom: 0;
`;

export const ContentDiv = styled.div`
  padding: 0 15px 15px 15px;
  display: flex;
  min-height: 100px;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
